const rules = {
	user: {
		static: [],
	},

	admin: {
		static: [
			//"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection"
		],
	},

	departamentos: {
		static: [
			"queues-page:view",
			"queues-page:edit",
			"queues-page:create",
			"queues-page:delete"
		],
	},

	conexões: {
		static: [
			"connections-page:view",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection"
		],
	},
};

export default rules;
